module.exports = __webpack_public_path__ + "3c4855134ba296550e6c4298728e9370.pdf";